import request from '@/utils/request'
const permissionURL = process.env.VUE_APP_PERMISSION_API
const ticketURL = process.env.VUE_APP_BASE_API
import { getToken } from '@/utils/cookies'

export const LOGINAPI = {
  // 获取当前用户所拥有的菜单权限
  getPermissionList: () =>
  request({
    url: permissionURL + 'menu/user/structure/',
    method: 'get',
    headers: {
      Authorization: 'Token ' + getToken()
    }
  }),

  // 获取知音楼登录二维码uuid & 是否扫码登录轮询接口
  getUUid: (params: any) => {
    const requestParams = params.type === 1 ? `type=${params.type}` : `type=${params.type}&uuid=${params.uuid}`
    return request({
      url: permissionURL + `qr/login/?${requestParams}`,
      method: 'get'
    })
  },

  // 知音楼登录token验证
  ssoLogin: (params: any) => {
    return request({
      url: permissionURL + 'login/verify/',
      method: 'GET',
      params
    })
  },


  getYachUserInfo: () =>
  request({
    url: permissionURL + 'user/info/yach/',
    method: 'get'
  })
}

export const USERAPI = {
  // 获取用户Token验证
  verifyToken: (params: any) =>
  request({
    url: ticketURL + 'ticket/token/verify',
    method: 'get',
    params
  }),

  // 获取用户对应APP权限
  getUserRoles: (params: any) =>
  request({
    url: ticketURL + 'ticket/user/roles',
    method: 'get',
    params
  })

}
